import { TaxFormDraft } from "../../types";

const escapeCsv = (value: string) => `"${value.replace(/"/g, '""')}"`;

const buildFileName = (draft: TaxFormDraft, signedDate: string) => {
  const fullName = [draft.taxpayerInfo?.legalFirstName, draft.taxpayerInfo?.legalLastName]
    .filter(Boolean)
    .join(" ")
    .replace(/[\\/:*?"<>|]/g, "");
  return `Tax form - ${fullName} - ${signedDate.replace(/\//g, "-")}.csv`;
};

export function generateTaxFormCsv(draft: TaxFormDraft, signedDate: string): File {
  const info = draft.taxpayerInfo;
  const rows: string[][] = [
    ["Legal first name", info?.legalFirstName ?? ""],
    ["Legal middle name", info?.legalMiddleName ?? ""],
    ["Legal last name", info?.legalLastName ?? ""],
    ["Business name", info?.businessName ?? ""],
    ["Address line 1", info?.addressLine1 ?? ""],
    ["Address line 2", info?.addressLine2 ?? ""],
    ["Zip code / postal code", info?.zipCode ?? ""],
    ["City", info?.city ?? ""],
    ["State / province", info?.state ?? ""],
    ["Country", info?.country ?? ""],
    ["TIN type", draft.tinType ?? ""],
    ["Tax ID", draft.taxId ?? ""],
    ["Certified TIN is correct", draft.certification?.tinCorrect ? "Yes" : "No"],
    ["Certified US/Canada person", draft.certification?.usOrCanadaPerson ? "Yes" : "No"],
    ["Signature", draft.certification?.signature ?? ""],
    ["Date", signedDate],
  ];
  // BOM keeps non-ASCII names readable when the admin opens the file in Excel
  const csv = "\uFEFF" + rows.map(([field, value]) => `${escapeCsv(field)},${escapeCsv(value)}`).join("\r\n");
  return new File([csv], buildFileName(draft, signedDate), { type: "text/csv" });
}
